import { defineMessages } from 'react-intl';

export default defineMessages({
    noInfo: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorContingencies.noInfo',
        defaultMessage: 'No information is available to display'
    },
    actionRequired: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorContingencies.Action Required',
        defaultMessage: 'Action Required'
    },
    dateAdded: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorContingencies.DATE ADDED',
        defaultMessage: "DATE ADDED"
    },
    dueDate: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorContingencies.DUE DATE',
        defaultMessage: 'DUE DATE'
    },
    potentialAction: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorContingencies.POTENTIAL ACTION',
        defaultMessage: 'POTENTIAL ACTION'
    },
    description: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorContingencies.DESCRIPTION',
        defaultMessage: 'DESCRIPTION'
    },
    title: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorContingencies.TITLE',
        defaultMessage: 'TITLE'
    }
});